<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-select style="width: 145px" @change="changeData($event,'ztstate')" class="marr4" v-model="stateTxt" size="mini"  filterable >
                <el-option
                        v-for="item in ztData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px" @change="changeData($event,'state')" @clear="clearsearch('state')" class="marr4" v-model="vc_khtype" size="mini"  filterable >
                <el-option
                        v-for="item in stateData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  @change="changeData($event,'kpf')" @clear="clearsearch('kpf')" class="marr4" v-model="vc_kpkhname" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_customer')">
                <el-option
                        v-for="item in kpfData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input @blur="gosearch" @clear="clearsearch('sou')" prefix-icon="el-icon-search" class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('button_search_for')" clearable size="mini"></el-input>
            <el-button class="marB10" icon="el-icon-search" circle @click="gosearch " size="mini" ></el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="goDd('add')">{{$t('paymentApplication_add_payment_request')}}</el-button>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="stateTxt"
                    :label="$t('form_state')"
                    width="80px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_id"
                    :label="$t('paymentApplication_application_number')"
                    width="100px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="typeTxt"
                    :label="$t('paymentApplication_type')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="$t('paymentApplication_payee')"
                    width="150px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('paymentApplication_payment_company')"
                    width="150px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gname"
                    :label="$t('paymentApplication_application_department')"
                    width="150px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_squname"
                    :label="$t('form_applicant')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_sqpay_total"
                    :label="$t('paymentApplication_application_amount')" align="right"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_pay_total" align="right"
                    :label="$t('paymentApplication_planned_amount')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_bz"
                    :label="$t('form_currency')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_rate"
                    :label="$t('form_exchange_rate')" align="right"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="$t('form_input_person')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    :label="$t('form_enter_time')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    :label="$t('form_notes')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="80"
                    :label="$t('form_operate')">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="goDd('edit',scope.row)">{{$t('paymentApplication_details')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div :class="baseerp+'div'" class="cgdia">
            <el-dialog
                    width="1100px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <add-aplic ref="sureOrder" :Data="Data" @cancelDialog="cancelDialog"></add-aplic>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import addAplic from "./addAplic";
    export default {
        components: {
            addAplic,
        },
        data() {
            return {
                baseerp:"",
                mid:0,
                treespan:5,
                rightspan:19,
                isright:true,
                Data:{},
                title:'',
                dialogVisible:false,
                loading:false,
                tableHeight:0,
                /*fpType:[
                    {i_type:2,vc_type:"采购发票"},
                    {i_type:3,vc_type:"运费发票"},
                    {i_type:32,vc_type:"港杂发票"},
                    {i_type:4,vc_type:"开证发票"},
                    {i_type:5,vc_type:"仓储发票"},
                    {i_type:6,vc_type:"保险发票"},
                ],*/
                //i_type:0,
                //i_khtype:0,
                //vc_type:"",
                stateData:[
                    //{isover:'4',vc_name:'待处理'},
                    //{isover:'0',vc_name:'待提交'},
                    //{isover:'1',vc_name:this.$t('state_review_approved')},
                    //{isover:'3',vc_name:this.$t('state_reviewing')},
                    //{isover:'-1',vc_name:'审核未通过'},
                ],
                vc_khtype:"",
                i_khtype:0,
                //isover:'0',
                //vc_isover:'待提交',
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                vc_khcreditcode:'',
                vc_address:'',
                vc_lxr:'',
                vc_tel:'',
                //compsData:[],
                //companyName:'',
                //companyId:0,
                ztData:[
                    {i_id:0,vc_name:this.$t('state_not_submitted')},
                    {i_id:1,vc_name:this.$t('state_review_approved')},
                    {i_id:2,vc_name:this.$t('state_completed')},
                    {i_id:3,vc_name:this.$t('state_reviewing')},
                    {i_id:11,vc_name:this.$t('state_funding_arrangement_in_progress')},
                    {i_id:-1,vc_name:this.$t('state_review_not_approved')},
                    {i_id:-3,vc_name:this.$t('state_invalid')},
                ],
                i_state:0,
                stateTxt:this.$t('state_not_submitted'),
                vc_search:"",
                tableData:[],
                highlightCurrentRow:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.khtype();
            //this.fptype();
            //this.getCompanyList();
            //this.getList(1);
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100 ;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            closeTree(){
                this.treespan=0;
                this.rightspan=24;
                this.isright=false;
            },
            openTree(){
                this.treespan=5;
                this.rightspan=19;
                this.isright=true;
            },
            goDd(type,row){
                //console.log('row',row);
                let map={
                    type:type,
                    row:row,
                    i_khtype:this.i_khtype,
                    i_kpkhid:this.i_kpkhid,
                    vc_kpkhname:this.vc_kpkhname,
                    vc_khcreditcode:this.vc_khcreditcode,
                    vc_address:this.vc_address,
                    vc_lxr:this.vc_lxr,
                    vc_tel:this.vc_tel,
                }
                if(type=="add"){
                    this.title=this.$t('paymentApplication_add_payment_request')
                    if(this.i_kpkhid==0){
                        this.$message.error(this.$t('paymentApplication_please_select_customer'));
                        return;
                    }
                }else if(type=='edit'){
                    this.title=this.$t('paymentApplication_payment_request')+row.i_id;
                }
                this.Data=map;
                this.dialogVisible=true;
            },
            cancelDialog(val){
                this.Data={};
                this.dialogVisible=false;
                if(val){
                    // this.i_kpkhid=0;
                    // this.vc_kpkhname='';
                    // this.vc_khcreditcode='';
                    // this.vc_address='';
                    // this.vc_lxr='';
                    // this.vc_tel='';
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }
            },
            //查询客户类型
            async khtype(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                    i_payapply:1,
                };
                let res = await API.khtype(param);
                if (res.code == 1) {
                    this.stateData = res.data.list;
                    this.vc_khtype = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_id;
                    this.getkhlist();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                    this.getfMou();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='ztstate'){
                    this.i_state=e;
                    let choo = this.ztData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.stateTxt=choo[0].vc_name;
                    }else{
                        this.stateTxt='';
                    }
                }
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';

                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                    //刷新列表
                }
                if(type=='state'){
                    this.i_khtype=e;
                    let choo = this.stateData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_khtype=choo[0].vc_name;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.vc_khcreditcode='';
                        this.getkhlist();
                    }else{
                        this.vc_khtype='';
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.vc_khcreditcode='';
                    }

                    //刷新列表
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('paymentApplication_please_select_the_invoice_type'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.vc_address=choo[0].vc_address;
                            this.vc_lxr=choo[0].vc_lxr;
                            this.vc_tel=choo[0].vc_tel;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.vc_address='';
                            this.vc_lxr='';
                            this.vc_tel='';
                        }
                        //刷新列表
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                    //刷新列表
                }
                this.getList();
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    //this.isover=null;
                    //this.vc_isover='';
                    this.i_khtype=0;
                    this.vc_khtype='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    //'i_type':this.i_type,
                    //'isover':this.isover,
                    //"i_gsid": this.companyId,
                    'i_khid':this.i_kpkhid,
                    'i_khtype':this.i_khtype,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'i_state':this.i_state,
                };
                var res = await API.list(param);
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList(1);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
        },
    }
</script>

<style  lang="scss" scoped>
    .pm{
        height: calc(100vh - 145px);
        /*overflow: auto;*/
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }
    //css
    //弹窗窗口
    .cgdia {
        //弹出层里内容 样式
        .el-dialog__body {
            max-height: 70vh !important;
            overflow-y: auto;
            padding: 0 20px 0 20px;
        }
        .el-dialog__headerbtn .el-dialog__close{
            color: white;
        }
        .el-dialog__title{
            color: white;
        }

    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>